import { Card, CardBody, Col, Row } from "reactstrap";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

type Props = {};

function BrandCampaignReportUpperCard({}: Props) {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col xl="2" lg="3">
            <CustomInput
              label="Campaign Name"
              placeholder=""
              type="text"
              name="rate"
              // value={formValues?.rate}
              // onChange={handleInputChange}
            />
          </Col>
          <Col xl="2" lg="3">
            <CustomInput
              label="Start Date"
              placeholder=""
              type="date"
              name="rate"
              // value={formValues?.rate}
              // onChange={handleInputChange}
            />
          </Col>
          <Col xl="2" lg="3">
            <CustomInput
              label="End Date"
              placeholder=""
              type="date"
              name="rate"
              // value={formValues?.rate}
              // onChange={handleInputChange}
            />
          </Col>

          <Col xl="2" lg="3">
            <ReusableDropdown
              options={[]}
              onChange={(value: any) => {
                console.log("types", value);
              }}
              DropdownHeading="Types"
              //   value={formValues?.products}
            />
          </Col>
          <Col xl="2" lg="3">
            <ReusableDropdown
              options={[]}
              onChange={(value: any) => {
                console.log("brand", value);
              }}
              DropdownHeading="Brand"
              //   value={formValues?.products}
            />
          </Col>
          <Col xl="2" lg="3">
            <ReusableDropdown
              options={[]}
              onChange={(value: any) => {
                console.log("classification", value);
              }}
              DropdownHeading="Classification"
              //   value={formValues?.products}
            />
          </Col>
        </Row>
        {/* <div className="d-flex justify-content-start gap-2"> */}

        <Row>
          <Col xl="4" lg="3">
            <button
              style={{
                backgroundColor: "#2e8dd3",
                color: "#ffffff",
                border: "none",
                marginTop: "35px",
                padding: "11px",
                borderRadius: "5px",
              }}
            >
              Show Result
            </button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default BrandCampaignReportUpperCard;
